import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Avatar } from "@/components/ProfileDialog";

let cache = null;
export const invalidateUserDirectory = () => { cache = null; };
const load = () => {
  if (!cache) cache = api.get("/users/directory").then((r) => r.data).catch(() => { cache = null; return []; });
  return cache;
};

export function UserTag({ id, name, testid }) {
  const [dir, setDir] = useState([]);
  useEffect(() => { load().then(setDir); }, []);
  if (!name && !id) return <span>-</span>;
  const u = dir.find((d) => (id && d.id === id)) || dir.find((d) => d.name === name);
  return (
    <span className="inline-flex items-center gap-1.5 align-middle" data-testid={testid}>
      <Avatar user={{ name: u?.name || name, avatar: u?.avatar }} className="h-6 w-6 text-[10px]" />
      <span>{u?.name || name}</span>
    </span>
  );
}
